import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {merge, Observable} from 'rxjs';
import {filter, map, startWith, take} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {PlayerState} from '../../store/player.state';

const defaultPoster = 'https://goodgame.ru/images/channel-logo.jpg';
const defaultPreview = 'https://hls.goodgame.ru/previews/';

@Component({
  selector: 'gg-poster',
  templateUrl: './poster.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PosterComponent implements OnInit {
  public posterSrc$: Observable<SafeStyle>;
  public visible$: Observable<boolean>;

  private preview: string;
  private poster: string;
  private isLive: boolean;

  constructor(private store: Store, private sanitize: DomSanitizer) {
    this.visible$ = this.store.select(state => state.player.isStarted)
      .pipe(
        filter(isStarted => isStarted),
        take(1),
        map(() => false),
        startWith(true),
      );

    this.posterSrc$ = merge(
      this.store.select(state => state.player.poster),
      this.store.select(state => state.player.apiData)
        .pipe(
          map(apiData => this.parseApiData(apiData)),
          filter(poster => !!poster),
        )
    ).pipe(
      map((src: string) => this.sanitize.bypassSecurityTrustStyle(`background-image: url(${src})`)),
    );

    // Fallback to default picture!
  }

  ngOnInit() {
  }

  private parseApiData(apiData: any): string {
    if (!apiData || !apiData.streamkey) {
      return '';
    }

    this.preview = defaultPreview + apiData.streamkey + '.jpg';
    this.poster = apiData.channel_poster;
    this.isLive = apiData.channel_status === 'live';

    //console.log('parseApiData', this.isLive ? this.poster : this.preview);
    return this.isLive ? this.poster : this.preview;
  }

}
